import React from "react";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarItemProps } from "../../types/";

const SidebarItem: React.FC<SidebarItemProps> = ({
  label,
  path,
  icon: Icon,
  collapsed,
  onClick, // ✅ ADD THIS
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = location.pathname === path;

  // ✅ HANDLE CLICK PROPERLY
  const handleClick = () => {
    if (onClick) {
      onClick(); // 🔥 logout or custom action
    } else if (path) {
      navigate(path); // 🔥 normal navigation
    }
  };

  const content = (
    <ListItemButton
      onClick={handleClick} // ✅ UPDATED
      sx={{
        borderRadius: "10px",
        mb: 0.5,
        px: collapsed ? 1 : 1.5,
        justifyContent: collapsed ? "center" : "flex-start",

        color: isActive
          ? "var(--primary-main)"
          : "var(--text-secondary)",
        backgroundColor: isActive
          ? "var(--primary-soft)"
          : "transparent",

        "&:hover": {
          backgroundColor: "var(--sidebar-hover)",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: collapsed ? 0 : 1.5,
          justifyContent: "center",
          color: "inherit",
        }}
      >
        <Icon fontSize="small" />
      </ListItemIcon>

      {!collapsed && (
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            fontSize: "14px",
            fontWeight: isActive ? 600 : 500,
          }}
        />
      )}
    </ListItemButton>
  );

  return collapsed ? <Tooltip title={label}>{content}</Tooltip> : content;
};

export default SidebarItem;